import React, { useState } from "react";
import "../SignIn/SignIn.css";
import "../ForgotPassword/ForgotPassword.css";
import "./OTP.css";
import {
  Image,
  Container,
  Col,
  Row,
  Button,
  InputGroup,
} from "react-bootstrap";
import Logo from "../../../assets/communityXlogo.svg";
import forgot from "../../../assets/forgot.png";
import { Link, useNavigate } from "react-router-dom";
import OTPInput, { ResendOTP } from "otp-input-react";

import { MdArrowBack } from "react-icons/md";
import { Forgotpassword } from "../../API/User/Forgotpassword";
import { VerifyOtp } from "./../../API/User/VerifyOtp";
import swal from "sweetalert";
import Loader from "../../Loader/Loader";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const OTP = () => {
  const navigate = useNavigate();
  const [OTP, setOTP] = useState("");
  const [OTPErr, setOTPErr] = useState("");
  const [loading, setLoading] = useState(false);

  // Redux data 1
  const Reduxdata = useSelector((state) => state);

  const timeperiod = Reduxdata.ForgotpswdCounter.ForgotPswdCounter * 60;

  // time counter
  const [timer, setTimer] = useState(timeperiod);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;

    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  const handleVerifyOtp = async () => {
    let check = true;
    const cityId = localStorage.getItem("Otp_cityId");
    if (OTP.length == 0) {
      setOTPErr("Please Enter the one-time verification code!");
      check = false;
    } else if (OTP.length < 6) {
      setOTPErr("Please Enter all 6 digits!");
      check = false;
    }

    if (check === true) {
      const payload = {
        token: localStorage.getItem("Otp_token"),
        otp: parseInt(OTP),
        mms_city_id: parseInt(cityId),
      };
      setLoading(true);
      const GetVerification = await VerifyOtp(payload, () => {
        navigate("/");
      });
      if (GetVerification === false) {
        setLoading(false);
        swal({
          title: "Internal Server Error!",
          icon: "error",
          buttons: "Ok",
          dangerMode: false,
        });
      } else {
        if (GetVerification.success === true) {
          setLoading(false);
          localStorage.setItem("Otp_token", GetVerification.token);
          localStorage.setItem("Otp_cityId", GetVerification.mms_city_id);
          swal({
            title: `${GetVerification.message} successfully!`,
            icon: "success",
            buttons: "Ok",
            dangerMode: false,
          }).then((success) => {
            if (success) {
              navigate("/create-new-password");
            }
          });
        } else {
          setLoading(false);
          swal({
            title: `${GetVerification.message}`,
            icon: "warning",
            buttons: "Ok",
            dangerMode: false,
          }).then((success) => {
            if (success) {
              navigate("/otp");
            }
          });
        }
      }
    }
  };

  const handleResentCode = async () => {
    setLoading(true);
    const Otp_email = localStorage.getItem("Otp_email");
    let payloadEmail = { check: 1, forgot_pwd_input: Otp_email };
    const Response = await Forgotpassword(payloadEmail, () => {
      navigate("/");
    });
    if (Response === false) {
    } else {
    }
    if (Response.success === true) {
      setLoading(false);
      localStorage.setItem("Otp_token", Response.token);
      swal({
        title: `${Response.p_responseMessage}`,
        icon: "success",
        buttons: "Ok",
        dangerMode: false,
      }).then((success) => {
        if (success) {
          setTimer(Response.timer * 60);
          navigate("/otp");
        }
        setOTP("");
        setOTPErr("");
      });
    } else {
      setLoading(false);
      swal({
        title: `${Response.p_responseMessage}`,
        icon: "warning",
        buttons: "Ok",
        dangerMode: false,
      });
    }
  };

  useEffect(() => {
    let intervalId = null;

    if (timer > 0) {
      intervalId = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [timer]);

  useEffect(() => {
    setTimer(timeperiod);
  }, [timeperiod]);

  useEffect(() => {
    if (OTP.length != 0) {
      setOTPErr("");
    }
  }, [OTP]);

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="main">
        <Container>
          <Row className="justify-content-md-center py-3 mobile-main">
            <Col md="6" className="page-content-left text-center hide-mobile">
              <Image src={forgot} className="my-5 py-5 imgwidth-100"></Image>
            </Col>
            <Col md="6" className="page-content-right">
              <div className="text-center mb-2">
                <Image src={Logo} className="logo_Image"></Image>
                <p className="sign-second mt-5 pt-5 pb-2">Forgot Password</p>
              </div>
              <Row>
                <div className="signemail mt-3 pt-0 pb-3 text-center">
                  <p className="text-center recive-text">
                    Please enter the one-time verification code sent to your
                    registered email
                  </p>
                  <p
                    className="text-center recive-text"
                    style={{ fontStyle: "italic" }}
                  >
                    (If you haven't received the One-time verification code in
                    your inbox, we kindly request you to check your spam
                    folder.)
                  </p>
                  <OTPInput
                    className="otp-section mt-4 mb-3"
                    value={OTP}
                    onChange={setOTP}
                    autoFocus
                    OTPLength={6}
                    otpType="number"
                    disabled={false}
                    maxTime={-1}
                  />
                  <div className="p-2">
                    {OTPErr ? (
                      <span className="star-required Errlabel-font_size">
                        {OTPErr}
                      </span>
                    ) : timer !== 0 ? (
                      <p style={{ color: "#e66100" }}>
                        The verification code sent will expire in{" "}
                        {formatTime(timer)} minutes
                      </p>
                    ) : (
                      <></>
                    )}
                  </div>
                  {/* <Link to="" className="resendotp-section">
                    <p className="forgot-text" onClick={handleResentCode}>Resend Code</p>
                  </Link> */}

                  <div
                    className="text-right"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <p
                      className="forgot-text"
                      onClick={handleResentCode}
                      style={{ paddingTop: 23 }}
                    >
                      Resend Code
                    </p>
                  </div>
                  <Button
                    variant="primary"
                    type="submit"
                    className="green-btn mt-2 mb-3 otp-submit"
                    onClick={handleVerifyOtp}
                  >
                    Verify
                  </Button>
                </div>
                <Link to="/forgot-password">
                  <p className="text-center back-btn">
                    <MdArrowBack />
                    Back
                  </p>
                </Link>
                <p
                  style={{
                    textAlign: "center",
                    color: "white",
                    padding: "1.5rem 1rem 0rem 1rem",
                  }}
                >
                  (Do not refresh the page!)
                </p>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default OTP;